/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Smart Home API
 * A smart home management system providing REST APIs for device integrations and automation
 * OpenAPI spec version: 1.0
 */

export type DevicesPlayState = (typeof DevicesPlayState)[keyof typeof DevicesPlayState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DevicesPlayState = {
  PlayStatePlaying: 'playing',
  PlayStatePaused: 'paused',
  PlayStateStopped: 'stopped',
} as const;
